module.exports = __webpack_public_path__ + "static/digging-cedfc0fcba3088d3bb8cd75c4fadc5ba.jpg";